export default __webpack_public_path__ + "static/mobile_1-d79042fa0d11b54a6e12111ab129db92.webp";